import type { MouseEvent, ReactElement } from 'react';

import { Tooltip } from '@treneo/shared/ui';

import { GridActionsCellItem } from '@mui/x-data-grid';

type Props = {
  icon: ReactElement;
  label: string;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
  showInMenu?: boolean;
  tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right';
  [key: string]: unknown;
};

export const TooltipGridActionsCellItem = ({
  label,
  tooltipPlacement = 'bottom',
  ...rest
}: Props) => (
  <Tooltip title={label} placement={tooltipPlacement}>
    <span style={{ display: 'inline-flex' }}>
      <GridActionsCellItem label={label} {...rest} />
    </span>
  </Tooltip>
);
